import React from "react";
import { Link } from "react-router-dom";
import { Container } from "reactstrap";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "./Policies.css";

const AcceptableUsePolicyPage = () => (
  <>
    <Navbar />
    <main className="hn-policies-main">
      <Container className="py-4 py-md-5">
        <p className="hn-policies-updated">Last Updated: 2026-03-12</p>
        <h1 className="hn-policies-title">Acceptable Use Policy</h1>
        <div className="hn-policies-body">
          <p>
            This Acceptable Use Policy (&quot;AUP&quot;) describes the uses of Hosting Noodle services that are permitted and prohibited. By using our services, you agree to comply with this AUP. We may update this policy from time to time; continued use after changes constitutes acceptance.
          </p>
          <h2 className="hn-policies-h2">Permitted use</h2>
          <p>
            You may use Hosting Noodle services for lawful business and personal purposes, including hosting applications, development and testing, data processing, and running workloads that do not violate applicable law or the rights of others.
          </p>
          <h2 className="hn-policies-h2">Prohibited use</h2>
          <p>
            You must not use our services to:
          </p>
          <ul>
            <li>Distribute malware, viruses, or other harmful code.</li>
            <li>Send unsolicited bulk email (spam) or operate phishing schemes.</li>
            <li>Host or distribute illegal content, including content that infringes intellectual property, promotes violence, or exploits minors.</li>
            <li>Attempt to gain unauthorized access to any system, network, or data (including scanning, brute force, or denial-of-service attacks).</li>
            <li>Use the services for cryptomining without prior written agreement.</li>
            <li>Resell or sublease resources in a way that violates our Terms of Service or creates abuse risk.</li>
            <li>Circumvent security controls, quotas, or usage limits.</li>
          </ul>
          <h2 className="hn-policies-h2">Abuse and enforcement</h2>
          <p>
            We investigate reports of abuse and may suspend or terminate services, remove content, or take other action we deem necessary to protect our network, customers, and third parties. We may cooperate with law enforcement and rights holders. Repeated or serious violations may result in permanent termination and referral to authorities where appropriate.
          </p>
          <h2 className="hn-policies-h2">Reporting abuse</h2>
          <p>
            If you become aware of abuse on our platform, please report it to us. See our <Link to="/report-abuse">Report Abuse</Link> page for contact details.
          </p>
          <p>
            Hosting Noodle reserves the right to interpret and apply this AUP in a manner consistent with our Terms of Service and applicable law.
          </p>
        </div>
      </Container>
    </main>
    <Footer />
  </>
);

export default AcceptableUsePolicyPage;
